import React, { useMemo, useState } from "react";
import { Formik } from "formik";
import { merge } from "lodash";

import KebijakanPerguruanTinggi from "../content/StandarSPMI/StandarSPMIPerguruanTinggi";
import KebijakanLainnya from "../content/StandarSPMI/StandarLainnya";
import TargetPerguruanTinggi from "../content/StandarSPMI/TargetPerguruanTinggi";

import {
  useHtmlClassService,
  setLayoutConfig,
  getInitLayoutConfig,
} from "../../../../../_metronic/layout";

import { Notice, YearSelect } from "../../../../../_metronic/_partials/controls";

const localStorageActiveTabKey = "TabsStandarSPMIActiveTab";

export function TabsStandarSPMI(params) {
  const getInitialTab = () => {
    const saved = localStorage.getItem(localStorageActiveTabKey);
    const parsed = Number(saved);

    if ([0, 1].includes(parsed)) {
      return parsed;
    }

    return 0;
  };

  const [key, setKey] = useState(() => getInitialTab());

  const [isLoading, setIsLoading] = useState(false);

  const htmlClassService = useHtmlClassService();

  const initialValues = useMemo(
    () =>
      merge(
        getInitLayoutConfig(),
        htmlClassService.config
      ),
    [htmlClassService.config]
  );

  const saveCurrentTab = (tab) => {
    if ([0, 1].includes(tab)) {
      localStorage.setItem(localStorageActiveTabKey, tab);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          setIsLoading(true);
          setLayoutConfig(values);
        }}
        onReset={() => {
          setIsLoading(true);
          setLayoutConfig(getInitLayoutConfig());
        }}
      >
        {() => (
          <>
            <Notice
              svg="/media/svg/icons/Home/Building.svg"
              style={{ marginBottom: "0px", boxShadow: "none" }}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div>
                  <strong style={{ fontSize: "18px" }}>PENETAPAN</strong>
                  <p className="mb-0">Standar Yang Ditetapkan Institusi</p>
                </div>
                <div>
                  <YearSelect />
                </div>
              </div>
            </Notice>

            <br />

            <div className="card card-custom">
              <div
                className="card-header card-header-tabs-line"
                style={{ minHeight: "50px" }}
              >
                <ul className="nav nav-dark nav-bold nav-tabs nav-tabs-line">
                  <li className="nav-item">
                    <a
                      className={`nav-link py-5 ${key === 0 ? "active" : ""}`}
                      onClick={() => {
                        setKey(0);
                        saveCurrentTab(0);
                      }}
                    >
                      Standar SPMI
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link py-5 ${key === 1 ? "active" : ""}`}
                      onClick={() => {
                        setKey(1);
                        saveCurrentTab(1);
                      }}
                    >
                      Standar Lainnya
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link py-5 ${key === 2 ? "active" : ""}`}
                      onClick={() => {
                        setKey(2);
                        saveCurrentTab(2);
                      }}
                    >
                      Standar Perguruan Tinggi
                    </a>
                  </li>
                </ul>
              </div>

              <div className="form">
                <div className="card-body">
                  <div className="tab-content">
                    <div className={`tab-pane ${key === 0 ? "active" : ""}`}>
                      <KebijakanPerguruanTinggi idSp={params.idSp} />
                    </div>

                    <div className={`tab-pane ${key === 1 ? "active" : ""}`}>
                      <KebijakanLainnya idSp={params.idSp} />
                    </div>

                    <div className={`tab-pane ${key === 2 ? "active" : ""}`}>
                      <TargetPerguruanTinggi idSp={params.idSp} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
}